import { Sad } from './Sad'
import { Bnb } from './Bnb'
import { Eth } from './Eth'
import { Eye } from './Eye'
import { Key } from './Key'
import { Web } from './Web'
import { Info } from './Info'
import { Love } from './Love'
import { Copy } from './Copy'
import { Moon } from './Moon'
import { Tick } from './Tick'
import { Close } from './Close'
import { Error } from './Error'
import { Money } from './Money'
import { Cross } from './Cross'
import { Arrow } from './Arrow'
import { Skull } from './Skull'
import { Gnosis } from './Gnosis'
import { Fantom } from './Fantom'
import { Loader } from './Loader'
import { SentTx } from './SentTx'
import { EyeOff } from './EyeOff'
import { Search } from './Search'
import { Goerli } from './Goerli'
import { Connect } from './Connect'
import { Gamepad } from './Gamepad'
import { ErrorTx } from './ErrorTx'
import { Hashtag } from './Hashtag'
import { History } from './History'
import { Warning } from './Warning'
import { Polygon } from './Polygon'
import { Twitter } from './Twitter'
import { Success } from './Success'
import { Chevron } from './Chevron'
import { Discord } from './Discord'
import { Arbitrum } from './Arbitrum'
import { NotFound } from './NotFound'
import { Optimism } from './Optimism'
import { Settings } from './Settings'
import { Coinbase } from './Coinbase'
import { Metamask } from './Metamask'
import { LogoFull } from './LogoFull'
import { CodeHands } from './CodeHands'
import { Avalanche } from './Avalanche'
import { NoContent } from './NoContent'
import { FlashFile } from './FlashFile'
import { LedgerLive } from './LedgerLive'
import { ExternalLink } from './ExternalLink'

export const icons = {
  sad: Sad,
  bnb: Bnb,
  eth: Eth,
  eye: Eye,
  key: Key,
  web: Web,
  info: Info,
  love: Love,
  copy: Copy,
  moon: Moon,
  tick: Tick,
  arrow: Arrow,
  close: Close,
  cross: Cross,
  error: Error,
  money: Money,
  skull: Skull,
  goerli: Goerli,
  gnosis: Gnosis,
  eyeOff: EyeOff,
  fantom: Fantom,
  loader: Loader,
  search: Search,
  sentTx: SentTx,
  connect: Connect,
  gamepad: Gamepad,
  errorTx: ErrorTx,
  hashtag: Hashtag,
  history: History,
  twitter: Twitter,
  warning: Warning,
  success: Success,
  chevron: Chevron,
  discord: Discord,
  polygon: Polygon,
  arbitrum: Arbitrum,
  optimism: Optimism,
  notFound: NotFound,
  settings: Settings,
  logoFull: LogoFull,
  metamask: Metamask,
  coinbase: Coinbase,
  codeHands: CodeHands,
  avalanche: Avalanche,
  noContent: NoContent,
  flashFile: FlashFile,
  ledgerlive: LedgerLive,
  externalLink: ExternalLink,
}
